import styled from 'styled-components';
// Mapeo de variantes a sus propiedades en el tema
const colorMap = {
    primary: (theme) => theme.colors.primary.normal,
    secondary: (theme) => theme.colors.secondary.normal,
    extra: (theme) => theme.colors.extra.normal,
    danger: (theme) => theme.colors.danger.normal,
    gray0: (theme) => theme.colors.grey0,
    disabled: (theme) => theme.colors.grey24,
    gray36: (theme) => theme.colors.grey36,
    gray60: (theme) => theme.colors.grey60,
    gray84: (theme) => theme.colors.grey84,
};
const getColor = (variant, theme) => {
    return colorMap[variant] ? colorMap[variant](theme) : theme.colors.grey84;
};
export const createText = (props, theme) => `
    font-size: ${theme.fontsV2[props.type].mobile[props.size].fontSize}px;
    line-height: ${theme.fontsV2[props.type].mobile[props.size].lineHeight}px;
    font-weight: ${theme.fontsV2.fontWeight[props.fontWeight]};
    color: ${getColor(props.variant, theme)};
    margin: 0;

    @media (min-width: ${theme.screen.lgMin}) {
        font-size: ${theme.fontsV2[props.type].desktop[props.size].fontSize}px;
        line-height: ${theme.fontsV2[props.type].desktop[props.size].lineHeight}px;
    }
`;
export const ClickableContainer = styled.div `
  cursor: pointer;
`;
